import { render } from "./FeatureView.vue?vue&type=template&id=0faf883c&scoped=true"
import script from "./FeatureView.vue?vue&type=script&lang=js"
export * from "./FeatureView.vue?vue&type=script&lang=js"

import "./FeatureView.vue?vue&type=style&index=0&id=0faf883c&lang=stylus&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0faf883c"]])

export default __exports__